import React from 'react';
import { Box, Typography } from '@mui/material';

const card = {
    background: 'linear-gradient(180deg, rgba(0,120,255,0.12) 0%, rgba(1,1,52,0.4) 100%)',
    border: '1px solid rgba(0,215,255,0.28)',
    borderRadius: '22px',
    padding: '20px',
    mt: 2,
};

const statGrid = {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: '12px',    // issue 5 — was 8px
    mt: '0px',      // issue 5 — was 12px
};

function Stat({ label, value }) {
    return (
        <Box>
            <Typography sx={{
                fontSize: '12px',           // issue 4 — was 11px (0.6875rem)
                textTransform: 'uppercase',
                letterSpacing: '0.6px',     // issue 4 — was 0.66px (0.06em)
                color: 'var(--ecal-lightgrey)',
                mb: 0.25,
            }}>
                {label}
            </Typography>
            <Typography sx={{
                fontSize: '24px',           // issue 2 — was 16px (1rem)
                fontWeight: 600,
                color: 'var(--ecal-white)',
                lineHeight: 1.2,
                mt: '4px',                  // issue 2 — was 0
            }}>
                {value ?? '—'}
            </Typography>
        </Box>
    );
}

function KeyInsight({ eventsThisMonth = 0, timeBooked = '0m', percentOfMonth = 0 }) {
    return (
        <Box sx={card}>
            <Typography sx={{
                fontSize: '12px',           // issue 1 — was 11.52px (0.72rem)
                textTransform: 'uppercase',
                letterSpacing: '2.16px',    // issue 1 — was 0.9216px (0.08em)
                color: 'var(--ecal-lightblue)',
            }}>
                Key Insight · Schedule Density
            </Typography>

            <Box sx={statGrid}>
                <Stat label="Events this month" value={eventsThisMonth} />  {/* issue 3 */}
                <Stat label="Time booked"       value={timeBooked} />       {/* issue 3 */}
                <Stat label="% of your month"   value={`${percentOfMonth}%`} /> {/* issue 3 */}
            </Box>

            <Box sx={{
                height: '8px',              // issue 6 — was 6px
                borderRadius: '999px',
                background: 'rgba(255,255,255,0.05)',
                overflow: 'hidden',
                mt: '16px',                 // issue 6 — was 12px
            }}>
                <Box sx={{
                    height: '100%',
                    width: `${Math.min(percentOfMonth * 4, 100)}%`,
                    background: 'linear-gradient(90deg, #00D456, #00D7FF, #0078FF)',
                    borderRadius: '999px',
                    transition: 'width 0.6s ease',
                }} />
            </Box>

            <Typography sx={{ fontSize: '12px', color: 'var(--ecal-lightgrey)', mt: '8px' }}>
                Resets on the 1st of each month.
            </Typography>
        </Box>
    );
}

export default KeyInsight;
